export const assetRegistry = {
  brand: {
    logoPrimary: '/assets/brand/logo-header.png',
    logoHeader: '/assets/brand/logo-header.png',
    logoSidebar: '/assets/brand/logo-horizontal-dark.png',
    logoHorizontalLight: '/assets/brand/logo-horizontal-light.png',
    logoHorizontalDark: '/assets/brand/logo-horizontal-dark.png',
    appIcon: '/assets/brand/icon-192x192.png',
    appIconLarge: '/assets/brand/icon-512x512.png',
    appIconMaskable: '/assets/brand/icon-512x512-maskable.png',
  },
  illustrations: {
    default: '/assets/illustrations/default.svg',
  },
} as const;

export type IllustrationName = keyof typeof assetRegistry.illustrations;
